import { motion } from 'motion/react';
import { serverNow } from '@/lib/api';
import { useSecondsUntil } from './time';

/**
 * A thin square-ended bar that drains until a server moment, with a label such as "Next question in 4".
 * Linear, because it is time; transform only, so it never costs a layout.
 */
export function NextBar({ from, to, label, tone = 'brand', className = '' }: { from: number; to: number; label: (secondsLeft: number) => string; tone?: 'brand' | 'cart' | 'ink'; className?: string }) {
  const left = useSecondsUntil(to) ?? 0;
  const total = Math.max(1, to - from); const remaining = Math.max(0, to - serverNow());
  const start = Math.min(1, remaining / total);
  const colour = tone === 'cart' ? 'var(--cart)' : tone === 'ink' ? 'var(--ink-2)' : 'var(--brand)';
  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <p className="flex items-baseline justify-between text-sm font-semibold text-ink-2">
        <span>{label(left)}</span>
      </p>
      <div className="h-1.5 overflow-hidden bg-surface-2" aria-hidden="true">
        <motion.div key={to} className="h-full origin-left" style={{ background: colour }}
          initial={{ scaleX: start }} animate={{ scaleX: 0 }} transition={{ duration: remaining / 1000, ease: 'linear' }} />
      </div>
    </div>
  );
}
